import { AccountTokenInfoResponse } from '../structures/response/AccountTokenInfoResponse';
import apiClient from './apiClient';
import { AccountPurpose } from '../enum/AccountPurpose';
import { AccountResponse } from '../structures/response/AccountResponse';

export const requestAllAccountTokens = (
  phone: string,
  code: string
): Promise<AccountTokenInfoResponse[]> => {
  const params = new URLSearchParams({
    phone,
    code,
    purpose: AccountPurpose.AGENT,
  });
  const url = `account/request-all-account-tokens?${params.toString()}`;
  return apiClient.get(url).then((r) => r.data);
};

export const signUp = async (
  phone: string,
  code: string
): Promise<AccountTokenInfoResponse> =>
  apiClient.post(`account/sign-up-agent`, { phone, code }).then((r) => r.data);

export const emailConfirmation = async (
  token: string
): Promise<AccountResponse> =>
  apiClient.patch('account/email-confirmation', { token }).then((r) => r.data);
